import { QueryClient } from '@tanstack/react-query'

import { queryKeys } from '../query-keys'
import { financialsRollupKeys } from './useFinancialsRollup'

/** Refresh every view whose financial actuals can change with time status or rates. */
export function invalidateTimeFinancialViews(queryClient: QueryClient) {
  const prefixes = [
    queryKeys.projects.all,
    ['project-budget-summary'],
    ['budget-breakdown'],
    ['burn-chart'],
    financialsRollupKeys.all,
    ['entity-financials'],
    ['profitability-cost-states'],
    ['profitability-by-role-enhanced'],
    ['profitability-bill-data-quality'],
    ['margin-trend'],
    ['revenue-recognition'],
    ['budget-summary'],
  ] as const

  for (const queryKey of prefixes) {
    queryClient.invalidateQueries({ queryKey })
  }
}
